<template>
  <section class="block subscribe-form flex justify-center">
    <div
      class="subscribe-form__inner flex flex-col justify-between align-center"
    >
      <div class="subscribe-form__content">
        <h2>Subscribe to our newsletter</h2>
        <p>
          Sign up to our eNewsletter to receive updates on content, resources,
          news and events from Compass – guiding action on elder abuse.
        </p>
      </div>
      <a
        :href="computedLink"
        aria-label="Newsletter subscription"
        class="button button--reverse-alt button--xl"
      >
        <span> Sign up now! </span>
        <i class="icon icon--lg">
          <Icon name="fa6-solid:arrow-right" />
        </i>
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
const { subscriptionLink } = storeToRefs(useConfigStore())
const subscriptionLinkUrl = computed(
  () => subscriptionLink.value?.link?.cached_url || '',
)
const isStoryLink = computed(
  () => subscriptionLink.value?.link?.linktype === 'story',
)
const computedLink = computed(() =>
  isStoryLink.value
    ? '/' + subscriptionLinkUrl.value
    : subscriptionLinkUrl.value,
)
</script>

<style lang="less" scoped>
section {
  @media print {
    .hidden();
  }

  &.subscribe-form {
    background-color: @color-secondary;
    margin-left: @gutter-lg;
    margin-right: @gutter-lg;

    @media @tablet {
      margin-left: 0;
      margin-right: 0;
    }

    .subscribe-form__inner {
      max-width: @screen-desktop;
      padding: @gutter @gutter-xl @gutter-lg;

      @media @tablet {
        padding: @gutter-xl;
      }

      @media @tablet {
        .flex-row();
      }

      .subscribe-form__content {
        .text-center();

        padding: 0 0 @gutter-lg;

        @media @tablet {
          .text-left();

          padding: 0 @gutter-xxl 0 0;
        }
        @media @desktop {
          padding: 0 @72px 0 0;
        }

        h2 {
          .font-2xl();

          color: @color-fill-normal;
          margin-bottom: @gutter-xxs;

          @media @tablet {
            margin-bottom: @gutter-xs;
          }
        }

        p {
          .font-headings();
          .font-base();

          margin-bottom: 0;
          color: @color-fill-pale;

          @media @desktop {
            .font-lg();
          }
        }
      }
    }
  }
}
</style>
